import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'
import {getToken} from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'home',
    redirect:'/index/user',
    component: HomeView,
    //路由嵌套
    children:[
      {path: '/index/group',component: () => import('../components/group.vue')},
      {path: '/index/package',component: () => import('../components/apk.vue')},
      {path: '/index/user',component: () => import('../components/user.vue')},
      {path: '/index/wgt',component: () => import('../components/mgt.vue')},
      {path: '/index/action',component: () => import('../components/action.vue')},
      {path: '/index/course',component: () => import('../components/course.vue')},
      {path: '/index/scene',component: () => import('../components/scene.vue')},
      {path: '/index/cover',component: () => import('../components/coverImage.vue')},
      {path: '/index/specification',component: () => import('../components/specification.vue')},

  ]
  },



  {
    path: '/index/login',
    name: 'login',
    component: () => import('../components/login.vue')
  },

  {
    path: '/index/loading2',
    name: 'loading2',
    component: () => import('../components/loading2.vue')
  },
  {
    path: '/index/loading',
    name: 'loading',
    component: () => import('../components/loading.vue')
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

// 路由守卫
router.beforeEach((to, from, next) => {
  let token=getToken()

  if (token==undefined  && to.path !== '/index/login') {
    // 如果未登录且访问的不是登录页，跳转到登录页
    next('/index/login')
  } else if (token!=undefined && to.path === '/index/login' ) {
    // 如果已登录且访问的是登录页，跳转到首页
    next('/index')
  } else {
    next() // 其他情况正常访问
  }
})

export default router
